import lzString from 'lz-string';

export class UtilLocalStorage {
  static itemSet<T>(key: string, value: T, jsonParse = true): void {
    if (!key) throw new Error('key is required');
    let valueToStore: string;
    if (jsonParse) {
      valueToStore = JSON.stringify(value);
    } else {
      valueToStore = value as string;
    }
    localStorage.setItem(key, this.strCompress(valueToStore));
  }

  static item<T>(key: string, jsonParse = true): T | undefined {
    if (!key) throw new Error('key is required');
    let value = localStorage.getItem(key);
    if (!value) return undefined;
    value = this.strDecompress(value);
    return jsonParse ? JSON.parse(value) as T : (value as T);
  }

  static itemRemove(key: string): void {
    if (!key) throw new Error('key is required');
    localStorage.removeItem(key);
  }

  private static strCompress(value: string): string {
    return lzString.compress(value);
  }

  private static strDecompress(value: string): string {
    return lzString.decompress(value);
  }
}